import "./Wrapper.css";

const Wrapper = ({ children }) => {
  return <div className="wrapper-main">{children}</div>;
};

export default Wrapper;
